(() => {
  const services = new Set(['build_redesign', 'migration', 'custom_development', 'ongoing_optimisation', 'app_support', 'other']);
  const interest = new URL(window.location.href).searchParams.get('service');
  if (services.has(interest)) document.querySelectorAll('[data-tiavola-service]').forEach(select => { select.value = interest; });
  document.querySelectorAll('.tiavola-home .mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
  const updateLanguageLinks = () => {
    document.querySelectorAll('[data-tiavola-language]').forEach(link => {
      const alternate = document.querySelector(`link[rel="alternate"][hreflang="${link.hreflang}"]`);
      const destination = new URL(alternate?.href || link.href, window.location.origin);
      destination.search = window.location.search;
      destination.hash = window.location.hash;
      link.href = destination.href;
    });
  };
  updateLanguageLinks();
  window.addEventListener('hashchange', updateLanguageLinks);
})();
